import { render, staticRenderFns } from "./matchingList.vue?vue&type=template&id=346b03b4&scoped=true&"
import script from "./matchingList.vue?vue&type=script&lang=js&"
export * from "./matchingList.vue?vue&type=script&lang=js&"
import style0 from "./matchingList.vue?vue&type=style&index=0&id=346b03b4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b03b4",
  null
  
)

export default component.exports